import React, { useState, useEffect, useRef } from 'react';

const SimpleAnimatedCounter = ({ end, suffix = '', prefix = '', duration = 2000, className = 'stat-number' }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);
  const elementRef = useRef(null);

  // Extract numeric part for animation
  const numericEnd = typeof end === 'string' ? parseInt(end.replace(/\D/g, '')) || 0 : end;
  const originalSuffix = typeof end === 'string' ? end.replace(/\d/g, '') : '';

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setIsVisible(true);
          setHasAnimated(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '0px 0px -100px 0px'
      }
    );

    const currentElement = elementRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [hasAnimated]);

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const increment = numericEnd / (duration / 50); // Update every 50ms
    
    const timer = setInterval(() => {
      start += increment;
      if (start >= numericEnd) {
        setCount(numericEnd);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 50);

    return () => clearInterval(timer);
  }, [isVisible, numericEnd, duration]);

  const displayValue = `${prefix}${count}${originalSuffix || suffix}`;

  return (
    <span ref={elementRef} className={className}>
      {displayValue}
    </span>
  );
};

export default SimpleAnimatedCounter;